<template>
  <v-card>
    <v-row>
      <v-col>
        <s-crud
          :config="config"
          title="Asignación de Personas a Turnos de Bus"
          :filter="filter"
          :rowDefault="false"
          searchInput
          ref="scrudBusTurnAssign"
        >
          <template v-slot:filter>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <s-select
                    v-model="filter.TrnID"
                    :items="turnOptions"
                    item-text="TrnName"
                    item-value="TrnID"
                    label="Turno de Bus"
                    @change="onTurnChange"
                  />
                </v-col>
              </v-row>
            </v-container>
          </template>
        </s-crud>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import HmnBusTurnService from "@/services/HumanResource/HmnBusTurnService";

export default {
  data() {
    return {
      config: {
        service: HmnBusTurnService,
        model: {
          BtaID: "ID",
          TrnID: "Turno",
          PrsID: "Trabajador",
          BtaJourneyType: "Tipo de Viaje",
          BtaStartDate: "Fecha Inicio",
          BtaEndDate: "Fecha Fin",
          StpIDDefault: "Paradero Default",
          StpIDAlternate: "Paradero Alternativo",
          BtaObservation: "Observación",
          BtaAttendance: "Asistencia"
        },
        headers: [
          { text: "ID", value: "BtaID" },
          { text: "Turno", value: "TrnID" },
          { text: "Trabajador", value: "PrsID" },
          { text: "Tipo de Viaje", value: "BtaJourneyType" },
          { text: "Fecha Inicio", value: "BtaStartDate" },
          { text: "Fecha Fin", value: "BtaEndDate" },
          { text: "Paradero Default", value: "StpIDDefault" },
          { text: "Paradero Alternativo", value: "StpIDAlternate" },
          { text: "Observación", value: "BtaObservation" },
          { text: "Asistencia", value: "BtaAttendance" }
        ]
      },
      filter: {
        TrnID: null
      },
      turnOptions: []
    };
  },
  methods: {
    onTurnChange() {
      this.$refs.scrudBusTurnAssign.refresh();
    }
  },
  created() {
    HmnBusTurnService.list().then((r) => {
      this.turnOptions = r.data;
    });
  }
};
</script>
